.item {
  display: flex;
  width: 100%;
  height: 3.2rem;
  padding: 0.8rem;
  gap: 0.8rem;
  align-items: center;
  user-select: none;

  &:first-child {
    margin-bottom: 1.6rem;
  }
}

.name {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  &[data-locked='false'] {
    cursor: pointer;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  width: 5.5rem;

  button {
    cursor: pointer;
    background: none;
    outline: none;
    border: none;
    width: 1.5rem;
    height: 1.5rem;
    color: var(--color-grayscale-manatee, #959bab);

    &:disabled {
      cursor: default;
    }
  }
}

.drag {
  display: none;
  cursor: grab;
  width: 1.6rem;
  min-width: 1.6rem;
  height: 1.6rem;
  align-items: center;
  justify-content: center;

  &:active {
    cursor: grabbing;
  }

  & svg {
    width: 6.66px;
    height: 10.93px;
  }
}
